<!-- // ------------------------------------------ All Referrals -------------------------------------------->
<br>
<div class="hidden-xs filter-sidebar" [ngClass]="{'filter-sidebar-closed col-md-1' : !filterOpenState, 'col-md-3' : filterOpenState}">
	<div class="panel panel-default">
		<div class="panel-body">
			<div class="filter-body">
				<span class="lead"> {{LOCALIZATION.referralFilter}} </span>
				<hr>
				<form>
					<div class="bottom-spacing">
						<label for="filterField">{{LOCALIZATION.filterBy}}</label> 					
						<select id="filterField" name="filterField" class="form-control" [(ngModel)]="filter.active">
						  <option *ngFor="let filter of filters" [ngValue]="filter">{{ filter.label }}</option>
						</select>						
					</div>
					<div class="bottom-spacing" *ngIf="filter.active && filter.active.name == 'status'">
						<select class="form-control" name="filterValue" [(ngModel)]="filter.value">
							<option value=""></option>
							<option value="PENDING">PENDING</option>
							<option value="COMPLETED">COMPLETED</option>
							<option value="CANCELLED">CANCELLED</option>
						</select>
					</div>
					<div>
                       <div class="primary-controls">
                           <button class="btn btn-default delete" (click)="clearFilter()">
                           		<span aria-hidden="true"></span> {{LOCALIZATION.clear}} 
                           </button>
                           <button class="btn btn-primary submit-button" (click)="applyFilter()">
                           		<span class="fas fa-filter" aria-hidden="true"></span> {{LOCALIZATION.filter}} 
                           </button>
                       </div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<div class="filter-sidebar" [ngClass]="{'col-xs-12 col-md-11' : !filterOpenState, 'col-xs-12 col-md-9' : filterOpenState}">
	<div class="dx-item-list-page">
		<div class="col-sm-12 col-md-12 ">
			<div>		
				<div>
					<div *ngIf="referrals && referrals.length > 0" class='pull-right primary-controls' style="margin-top: 20px">
						<button class="btn btn-primary btn-circle"
							(click)="loadReferrals()" 
							[disabled]="inprogress"
							title="{{LOCALIZATION.refresh}}">
							<i class="fas fa-sync"></i>
						</button>
						<button *ngIf="referrals && selectedReferrals.selected > 0 && selectedReferrals.canComplete"
							class="btn btn-circle btn-success" 
							title="Complete referrals"
							(click)="onCompleteReferral()">
							<i class="fa fa-check-circle" aria-hidden="true"></i>
						</button>
						<button *ngIf="referrals && selectedReferrals.selected > 0 && selectedReferrals.canCancel"
							class="btn btn-circle btn-danger"
							title="Cancel referral processing" 
							(click)="onCancel()">
							<i class="fa fa-times-circle" aria-hidden="true"></i>
						</button>
					</div>
				</div>
				<table *ngIf="referrals && referrals.length > 0" class='table table-hover table-condensed dx-table'>
					<thead>
						<tr>
							<th class="dx-checkbox-col">
								<label style="display: inline;"
									class="control control--checkbox"> 
									<input aria-label="Select all" 
										type="checkbox"
										[(ngModel)]="selectedReferrals.all"
										(click)="toggleAllReferrals()" />
									<div class="control__indicator"></div>
								</label>
							</th>
							<th>{{LOCALIZATION.task}}</th>
							<th>{{LOCALIZATION.batch}}</th>
							<th>{{LOCALIZATION.document}}</th>
							<th>{{LOCALIZATION.status}}</th>
							<th class="hidden-xs">{{LOCALIZATION.dueDate}}</th>
							<th class="hidden-sm hidden-xs">{{LOCALIZATION.created}}</th>
							<th class="hidden-sm hidden-xs">{{LOCALIZATION.closed}}</th>
							<th>{{LOCALIZATION.referredTo}}</th>
							<th class="hidden-sm hidden-xs">{{LOCALIZATION.reason}}</th>
							<th class="text-center" style="width: 10%">{{LOCALIZATION.actions}}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor='let referral of referrals'>
							<td><label class="control control--checkbox">
								 <input [(ngModel)]="referral.selected"
									    (change)="toggleReferralId(referral.id)" 
									    type="checkbox" />
								 <div class="control__indicator"></div>
								</label>
							</td>
							<td><p class="truncate" title="{{referral.taskName}}">{{referral.taskName}}</p></td>
							<td><p class="truncate" title="{{referral.batchName}}">{{referral.batchName}}</p></td>
							<td>
								<p title="{{referral.productTitle}}"
									class='dd-text-collapse' 
									ddTextCollapse
									[ddTextCollapseMaxLength]="80" 
									[ddTextCollapseText]="referral.productTitle">
								</p>
							</td>
							<td><p class="truncate" title="{{referral.status}}">{{referral.status}}</p></td>
							<td class="hidden-xs"><p class="truncate" title="{{LOCALIZATION.dueDate}}">{{referral.dateDueStr}}</p></td>
							<td class="hidden-sm hidden-xs"><p class="truncate" title="Referral created date">{{referral.dateCreatedStr}}</p></td>
							<td class="hidden-sm hidden-xs"><p class="truncate" title="Referral closed date">{{referral.dateClosedStr}}</p></td>
							<td><p class="truncate" title="Referred to">{{referral.owner}}</p></td>
							<td class="hidden-sm hidden-xs"><p class="truncate" title="Referral reason">{{referral.reviewReason}}</p></td>
	                        <td class="text-center">                         
			                    <div *ngIf="'PENDING' == referral.status" class="dropdown" id="workflow-operations-div" ngbDropdown>
								  <button ngbDropdownToggle
									  type="button"
									  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
									  aria-haspopup="true"
									  aria-expanded="false"
									  [attr.aria-label]="LOCALIZATION.actions"
									  title="{{LOCALIZATION.actions}}"
									  style="border: 0; background: transparent;">
										<i class="nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
								  </button>								  
			                      <ul class="dropdown-menu custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
	                                <li role="menuitem"><a (click)="onCancel(referral.id)" title="Cancel this referral" class="pointMe menuitem-danger">{{LOCALIZATION.cancel}}</a></li>
	                                <li role="menuitem"><a (click)="onCompleteReferral(referral.id)" title="Complete this referral" class="pointMe menuitem-success">{{LOCALIZATION.complete}}</a></li>                          
	                              </ul>
	                            </div>
	                        </td> 							
						</tr>
					</tbody>
				</table>
				<div *ngIf="!inprogress && (!referrals || referrals.length == 0)">
					<i>{{LOCALIZATION.resultsEmpty}}</i>
				</div>
				<div *ngIf="inprogress">
					<i>{{LOCALIZATION.loading}}</i>
				</div>
			</div>
		</div>
		<div class="tab-pagination-container">
			<div class="text-center" *ngIf="referrals && referrals.length > 0">
				<div style="display: inline-flex; gap: 5px; align-items: center; margin-bottom: 10px;">
					  <ngb-pagination class="pagination custom-page pagination-sm"
					    [(page)]="pagination.page" 
					    [pageSize]="pagination.elementsPerPage"
					    [collectionSize]="pagination.totalElements" 
					    (pageChange)="pagination.pageChanged($event)"
					    [maxSize]="5"
					    [boundaryLinks]="true"
					    previousText="&#xf053;"
					    nextText="&#xf054;"
					    firstText="&#xf053;&#xf053;"
					    lastText="&#xf054;&#xf054;">
					  </ngb-pagination>					
				</div>					
			</div>
		</div>
	</div>
</div>